<template>
  <div class="subscription-type">
    <div class="top">
      <headline-view v-bind:title="title" />
    </div>
    <div v-if="subscriptionTypeLoaded" class="subscription-container">
      <div class="headline">{{ subscriptionType.name }}</div>
      <div class="subtitle" v-html="subscriptionType.subtitle"></div>
      <div class="subtitle-invoice"><span><b>Important:</b> Payment via bank transfer / invoice is only possible with a 5-year license available on our <a v-bind:href="subscriptionType.shop_url" target="_blank" class="shop_link">shop</a>.</span></div>
      <div class="price">
        <span class="name"
          >One {{ subscriptionType.interval.toLowerCase() }} subscription x
          1</span
        >
        <span class="value"
          >{{ (Math.round(calcPrice * 100) / 100).toFixed(2) }} €</span
        >
      </div>
      <div class="tax">
        <span class="name"
          >Tax
          <span v-if="tax > 0 || parseInt(tax) == 0">({{ tax }}%)</span></span
        >
        <span class="value"
          >{{ (Math.round(calcTax * 100) / 100).toFixed(2) }} €</span
        >
      </div>
      <div class="discount" v-if="discount">
        <span class="name"
          >Discount <span>({{ discount }}%)</span></span
        >
        <span class="value"
          >-{{ (Math.round(calcDiscount * 100) / 100).toFixed(2) }} €</span
        >
      </div>
      <div class="transaction-fee" v-if="discount == 100">
        <span class="name">Transaction fee</span>
        <span class="value"
          >{{ (Math.round(calcTransactionFee * 100) / 100).toFixed(2) }} €</span
        >
      </div>
      <div class="total">
        <span class="name">Total</span>
        <span class="value"
          >{{ (Math.round(calcTotal * 100) / 100).toFixed(2) }} €</span
        >
      </div>
      <div class="subscription-type-logo">
        <img
          v-bind:src="
            require('@/assets/subscription-types/' +
              subscriptionType.category.toLowerCase() +
              '.png')
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import HeadlineView from "@/components/Checkout/Headline.vue";

export default {
  name: "subscription-type-view",
  data() {
    return {
      title: "Data Update Service",
    };
  },
  props: {},
  components: {
    "headline-view": HeadlineView,
  },
  computed: {
    subscriptionType() {
      return this.$store.state.subscriptionType;
    },
    subscriptionTypeLoaded() {
      return this.$store.state.subscriptionTypeLoaded;
    },
    calcPrice() {
      return this.subscriptionType.price / 100;
    },
    calcDiscount() {
      let discount = (this.calcTotalWithoutDiscount / 100) * this.discount;
      return Math.round(discount * 100) / 100;
    },
    calcTransactionFee() {
      if (
        this.getCountryWithId(this.$store.state.customerData.country) != null
      ) {
        if (
          this.getCountryWithId(this.$store.state.customerData.country).tax !=
          null
        ) {
          if (this.$store.state.vatCheckSuccessfull) {
            return 1;
          }
          return (
            1 +
            (1 *
              this.getCountryWithId(this.$store.state.customerData.country)
                .tax) /
              100
          );
        }
      }
      return 1;
    },
    calcTax() {
      if (
        this.getCountryWithId(this.$store.state.customerData.country) != null
      ) {
        if (
          this.getCountryWithId(this.$store.state.customerData.country).tax !=
          null
        ) {
          if (this.$store.state.vatCheckSuccessfull) {
            return 0;
          }
          return (
            (this.calcPrice *
              this.getCountryWithId(this.$store.state.customerData.country)
                .tax) /
            100
          );
        }
      }
      return 0;
    },
    calcTotalWithoutDiscount() {
      this.$store.commit("assignPriceWithoutTax", this.subscriptionType.price);
      let total = this.subscriptionType.price / 100 + this.calcTax;
      return total;
    },
    calcTotal() {
      let total = this.calcTotalWithoutDiscount;
      if (this.calcDiscount > 0) {
        total = total - this.calcDiscount;
      }
      if (total == 0) {
        total = this.calcTransactionFee;
      }
      this.$store.commit("assignPriceWithTax", total * 100);
      return total;
    },
    tax() {
      if (
        this.getCountryWithId(this.$store.state.customerData.country) != null
      ) {
        if (
          this.getCountryWithId(this.$store.state.customerData.country).tax !=
          null
        ) {
          if (this.calcTax == 0) {
            return 0;
          } else {
            return this.getCountryWithId(this.$store.state.customerData.country)
              .tax;
          }
        }
      }
      return false;
    },
    discount() {
      if (this.$router.history.current.query.discount != null) {
        if (typeof this.$store.state.subscriptionDiscount != "undefined") {
          return this.$store.state.subscriptionDiscount.percentage;
        }
      }
      if (this.$router.currentRoute.name == "order") {
        let charged_price = this.$store.state.subscription.charged_price;
        let total = Math.round(this.calcTotalWithoutDiscount * 100);
        if (total == charged_price) {
          return false;
        }
        return ((100 / total) * (total - charged_price)).toFixed(2);
      }
      return false;
    },
  },
  methods: {
    getCountryWithId(countryId) {
      for (let i = 0; i < this.$store.state.countries.length; i++) {
        if (this.$store.state.countries[i].id == countryId) {
          return this.$store.state.countries[i];
        }
      }
      return null;
    },
  },
  async mounted() {
    if (
      this.$router.currentRoute.name != "order" &&
      !this.$router.currentRoute.name.includes("subscription")
    ) {
      if (this.$router.history.current.query.discount != null) {
        await this.$store.dispatch("getSubscriptionDiscount");
      }
      await this.$store.dispatch(
        "getSubscriptionType",
        this.$router.history.current.query.subscription_type_id
      );
    }
    this.$store.commit("assignSubscriptionTypeLoaded", true);
  },
};
</script>

<style scoped>
.subscription-type {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.subscription-container {
  box-shadow: 0px 0px 12px rgb(194, 193, 193);
  height: 80%;
  width: 100%;
  display: flex;
  border-radius: 6px;
  position: relative;
  flex-direction: column;
  padding: 30px 20px 0px 20px;
  font-size: 12px;
}

.subscription-type-logo img {
  object-fit: contain;
  height: 50px;
  width: 100px;
}
.subscription-type-logo {
  position: absolute;
  top: 10px;
  right: 20px;
  height: 50px;
  width: 100px;
  display: flex;
}

.subscription-type .top {
  display: flex;
  width: 100%;
  height: 20%;
}

.subscription-container .headline {
  height: 22%;
  width: 83%;
  font-size: 16px;
  color: #888888;
  display: flex;
  align-items: flex-start;
}

.subscription-container .subtitle {
  height: 25%;
  font-size: 11px;
  color: #7c7474;
  display: flex;
  align-items: flex-start;
}

.subscription-container .subtitle-invoice {
  font-size: 11px;
  color: #de1a1a;
  border-bottom: 1px solid #e7e7e7;
}

.subscription-container .shop_link {
  font-weight: bold;
  color: #de1a1a;
  cursor: pointer;
}

.price .name {
  width: 50%;
}
.price .value {
  width: 50%;
  text-align: right;
}
.price {
  margin-top: 1%;
  height: 10%;
  display: flex;
  align-items: center;
}

.tax .name {
  width: 50%;
}
.tax .value {
  width: 50%;
  text-align: right;
}
.tax {
  height: 10%;
  display: flex;
  align-items: center;
}

.discount .name {
  width: 50%;
}
.discount .value {
  width: 50%;
  text-align: right;
}
.discount {
  height: 10%;
  display: flex;
  align-items: center;
}
.transaction-fee .name {
  width: 50%;
}
.transaction-fee .value {
  width: 50%;
  text-align: right;
}
.transaction-fee {
  height: 10%;
  display: flex;
  align-items: center;
  margin-bottom: 1%;
}

.total {
  border-top: 1px solid #e7e7e7;
  height: 20%;
  display: flex;
  align-items: center;
}
.total .value {
  color: #ffc20f;
  font-weight: bold;
  width: 50%;
  text-align: right;
}
.total .name {
  font-weight: bold;
  width: 50%;
}
</style>
